/**
 * Pure utility functions (no UI code)
 */

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function timeout(ms, promise) {
    return new Promise(function (resolve, reject) {
        setTimeout(() => {
            reject(new Error("Timeout"));
        }, ms);
        promise.then(resolve, reject);
    });
}

function promptValue(message, defaultValue) {
    let newValue = prompt(message, defaultValue);
    if (newValue == null) return;

    switch (typeof defaultValue) {
        case "boolean":
            return newValue === "true";
        case "number":
            return parseInt(newValue);
        default:
            return newValue;
    }
}

function hexToBinary(hex) {
    return hex.split('').map(char => {
        return parseInt(char, 16).toString(2).padStart(4, '0');
    }).join('');
}

/**
 * Pads a device_id to 16 characters with leading zeros
 * @param {string} deviceId - The device ID to pad
 * @returns {string} The padded device ID
 */
function padDeviceId(deviceId) {
    if (!deviceId) return deviceId;
    return deviceId.toString().padStart(16, '0');
}

function checkVersion(versionString, baseVersion) {
    const versionMatch = versionString.match(/^v?(\d+)\.(\d+).*$/);
    if (!versionMatch) throw new Error(`Invalid version string: ${versionString}`);

    const [_, major, minor] = versionMatch;
    const [baseMajor, baseMinor] = baseVersion.split('.').map(Number);

    if (parseInt(major) > baseMajor) return true;
    if (parseInt(major) < baseMajor) return false;

    if (parseInt(minor) > baseMinor) return true;
    if (parseInt(minor) < baseMinor) return false;

    return true;
}

function forceReload() {
    navigator.serviceWorker.controller.postMessage({type: 'CLEAR_CACHE'});
    setTimeout(() => {
        window.location.reload(true);
    }, 1000);
}

const httpStatus = {
    '200': 'OK',
    '201': 'Created',
    '202': 'Accepted',
    '203': 'Non-Authoritative Information',
    '204': 'No Content',
    '205': 'Reset Content',
    '206': 'Partial Content',
    '300': 'Multiple Choices',
    '301': 'Moved Permanently',
    '302': 'Found',
    '303': 'See Other',
    '304': 'Not Modified',
    '305': 'Use Proxy',
    '306': 'Unused',
    '307': 'Temporary Redirect',
    '400': 'Bad Request',
    '401': 'Unauthorized',
    '402': 'Payment Required',
    '403': 'Forbidden',
    '404': 'Not Found',
    '405': 'Method Not Allowed',
    '406': 'Not Acceptable',
    '407': 'Proxy Authentication Required',
    '408': 'Request Timeout',
    '409': 'Conflict',
    '410': 'Gone',
    '411': 'Length Required',
    '412': 'Precondition Required',
    '413': 'Request Entry Too Large',
    '414': 'Request-URI Too Long',
    '415': 'Unsupported Media Type',
    '416': 'Requested Range Not Satisfiable',
    '417': 'Expectation Failed',
    '418': 'I\'m a teapot',
    '429': 'Too Many Requests',
    '500': 'Internal Server Error',
    '501': 'Not Implemented',
    '502': 'Bad Gateway',
    '503': 'Service Unavailable',
    '504': 'Gateway Timeout',
    '505': 'HTTP Version Not Supported',
};

export {
    timeout,
    promptValue,
    checkVersion,
    sleep,
    httpStatus,
    forceReload,
    hexToBinary,
    padDeviceId
};
